export default "<div class=\"sign-in-container\">\r\n    <app-login></app-login>\r\n</div>";